<template>
  <zen-one
  :showuserinfo="false"
  title="Pentadbiran"
  :crumbs="crumbs"
  >
  <z-page
  title="Tadbir Peranan"
  >

  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Sunting
    </template>

    <w-form
      ref="form"
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >
    <!-- <z-lookup
      label="Modul"
      name="module"
      url="administration.modulelookup"
      :sort="false"
      :cache="false"

      v-model="form.module_id"
    /> -->
    <z-input label="Nama Peranan" v-model="form.display_name" name="display_name" :validators="[validators.required]" />
    <br>
    <template v-if="form.id == 0">
    <w-select
          :items="jenis_pengguna"
          label="Jenis Pengguna"
          v-model="form.lkp_jenis_pengguna_id"/>
    </template>
    <br>
    <w-switch class="mt4" width="col-12" v-model="form.status" label="Status" />
    </w-form>


    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      <w-button
      class="ml1"
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        SIMPAN
      </w-button>
    </template>


  </w-dialog>


  <z-table
    ref="tbluser"
    title="Senarai Peranan"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class=""
  >

    <template #button>
      <w-button
      dark
      class="indigo-dark2--bg ml1 fs-2"
      @click="add()"
      >
        <w-icon class="mr1" xs>fal fa-plus</w-icon> TAMBAH
      </w-button>
    </template>

    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>

    </template>

    <template #item-cell.icon="{ item, label, header, index }">
      <w-icon md class="mr1" >{{ item.icon }}</w-icon>
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
        </w-button>
        &nbsp;  
        <!-- <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
        </w-button> -->
        <w-button
          bg-color="info-dark1"
          dark
          tile
          :route="$route(resourceurl + '.show',item.id)"
          class="be fs-2"
        >
          <w-icon xs class="mr2" >fal fa-eye</w-icon> Papar
        </w-button>
        &nbsp;
         <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2"> fal fa-trash</w-icon>PADAM
        </w-button>
       &nbsp;
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    menu: [Array, Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'administration.role',
      reload: true,
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Peranan', route: '/administration/role' }
      ],
      form: {
        id: 0,
        module_id: 0,
        display_name: '',
        lkp_jenis_pengguna_id:'',
        status: '',
      },
      jenis_pengguna:[],
    }
  },
  methods: {
      add(){
          this.form = {
              id : 0,
              status : 1,

          }

          this.dialog.show = true
          this.form.saveButton = "Save"
      },

      destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },
      getlkpJenisPengguna(){
        this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
          this.jenis_pengguna = res
        })
      },
  },
  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
    this.getlkpJenisPengguna()

  },
}
</script>
